var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.contract)?_c('collapsed-section',{staticClass:"mb-5",attrs:{"title":"Contract","open":true}},[(_vm.error)?_c('error-banner',{attrs:{"message":_vm.error}}):[_c('pdf-container'),(_vm.signatureRequired)?_c('signature-pad'):_vm._e()]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }